module.exports = __webpack_public_path__ + "img/banner-main.png";